import { render, staticRenderFns } from "./AcompanhamentoRegional.vue?vue&type=template&id=86ce6aa2&scoped=true&"
import script from "./AcompanhamentoRegional.vue?vue&type=script&lang=js&"
export * from "./AcompanhamentoRegional.vue?vue&type=script&lang=js&"
import style0 from "./AcompanhamentoRegional.vue?vue&type=style&index=0&id=86ce6aa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ce6aa2",
  null
  
)

export default component.exports